import { INSTITUTION_WIDE_BRANCH_ID } from '@/api/approvals-types'
import type { Branch } from '@/api/types'
import { branchLabel } from '@/lib/branch'

/**
 * Which branch a request belongs to, in words.
 *
 * `directoryAvailable` is false while no module owns branches as records, so every code and name
 * arrives null and the identifier is the only true thing there is to show. That is the honest
 * answer rather than a placeholder for a better one: an invented label would be a name the
 * institution never gave this branch, and a bare "Branch" names nothing at all.
 *
 * The institution-wide sentinel is a different fact again — user administration, role definitions
 * and product configuration belong to no branch — and reads as itself rather than as "Branch 0".
 */
export function branchDisplayName(branchId: string, branches: Branch[]): string {
  if (branchId === INSTITUTION_WIDE_BRANCH_ID) {
    return 'Institution-wide'
  }

  const match = branches.find((branch) => branch.id === branchId)
  return match ? branchLabel(match) : `Branch ${branchId}`
}
